
<div [class.shimmer]="shimmer">
  <svg-icon *ngIf="icon"
            [name]="icon"
            [svgStyle]="{
              'width.px': size,
              'fill': color,
              'stroke': '#000',
              'stroke-width.px': 10,
              'stroke-dasharray': '2,2',
              'stroke-linejoin': 'round'
            }"></svg-icon>
</div>
